import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from 'utils/connectFC';

import {
  PromotionTableFC,
  PromotionTableFCProps,
} from 'root/promotions/components/PromotionTable/PromotionTableFC';

const useStrings = (): PromotionTableFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      tablePromotionFields: {
        promotionType: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.promotionType',
        }),
        startDate: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.startDate',
        }),
        endDate: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.endDate',
        }),
        dates: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.dates',
        }),
        orders: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.orders',
        }),
        customers: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.customers',
        }),
        sales: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.sales',
        }),
        newUsers: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.newUsers',
        }),
        gmvImpact: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.gmvImpact',
        }),
        totalSpend: intl.formatMessage({
          id: 'components.assignedPromotions.tableEndedPromotionFields.totalSpend',
        }),
      },
      messages: {
        errorFetchingAssignedPromotions: intl.formatMessage({
          id: 'components.assignedPromotions.messages.errorFetchingAssignedPromotions',
        }),
        pagerShowRowsFrom: intl.formatMessage({
          id: 'components.assignedPromotions.messages.pagerShowRowsFrom',
        }),
      },
    }),
    [intl],
  );
};

export type PromotionTableProps = Omit<PromotionTableFCProps, 'strings'>;

export const PromotionTable = connectFC(PromotionTableFC, (props: PromotionTableProps) => {
  const strings = useStrings();

  return {
    ...props,
    strings,
  };
});
